import { api_ } from '@shared/plugIn/axios';

import { bugoAgencyWorkerUpdate } from './user.interface';

export const nonAdminUserUpdate = async (userUpdate: bugoAgencyWorkerUpdate) => {
  const { data: user } = await api_.patch(`auth/me/detail`, userUpdate);
  return user;
};
